import classnames from 'classnames';
import React from 'react';

import styles from './ThreeDots.module.scss';

interface ThreeDotsProps {
  className?: string;
}

export const ThreeDots = ({ className }: ThreeDotsProps) => {
  return (
    <div
      data-testid="three-dots"
      className={classnames(styles.root, className)}
    >
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
};
